import * as api from "../../services/advert-service";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createAdvert = createAsyncThunk(
  "advert/create",
  async (formData, { rejectWithValue }) => {
    try {
      return await api.createAd(formData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const editAdvert = createAsyncThunk(
  "advert/edit",
  async (payload, { rejectWithValue }) => {
    // payload: { id, data }
    try {
      return await api.editAd(payload);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const toggleAdvertStatus = createAsyncThunk(
  "advert/toggleStatus",
  async (payload, { rejectWithValue }) => {
    // payload: { id, status }
    try {
      return await api.toggleAdStatus(payload);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const deleteAdvert = createAsyncThunk(
  "advert/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.deleteAd(id);
      return { id, ...response };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const restoreAdvert = createAsyncThunk(
  "advert/restore",
  async (id, { rejectWithValue }) => {
    try {
      return await api.restoreAd(id);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchAllAdverts = createAsyncThunk(
  "advert/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const {data} = await api.getAllAds(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchPositions = createAsyncThunk(
  "advert/fetchPositions",
  async (_, { rejectWithValue }) => {
    try {
      const {data} =  await api.getPositions();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchAdvertStats = createAsyncThunk(
  "advert/fetchStats",
  async (id, { rejectWithValue }) => {
    try {
      const {data} = await api.getAdStats(id);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchAdvertsSummary = createAsyncThunk(
  "advert/fetchSummary",
  async (params, { rejectWithValue }) => {
    try {
      const {data} = await api.getAdsSummary(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
